export const chargingSessionsResource = {
  name: 'Charging Session |||| Charging Sessions',
  fields: {
    id: 'Session ID',
    app_session_id: 'App Session ID',
    user_id: 'User ID',
    rfid_user_id: 'RFID User ID',
    charger_id: 'Charger ID',
    connector_id: 'Connector ID',
    site_id: 'Site ID',
    session_start_time: 'Start Time',
    session_end_time: 'End Time',
    duration_seconds: 'Duration',
    energy_delivered: 'Energy Delivered',
    meter_start: 'Meter Start',
    meter_stop: 'Meter Stop',
    payment_status: 'Payment Status',
    payment_method: 'Payment Method',
    total_cost: 'Total Cost',
    initiated_by: 'Initiated By',
    user_name: 'User Name',
    user_phone: 'User Phone',
    user_email: 'User Email',
    site_name: 'Site Name',
    charger_name: 'Charger Name',
  },
  list: {
    title: 'Charging History',
    session: 'Session',
    user: 'User',
    site: 'Site',
    charger: 'Charger',
    startTime: 'Start Time',
    type: 'Type',
    totalSessions: 'Sessions',
    loadingSessions: 'Loading sessions...',
    rfidUser: 'RFID User',
    unknownUser: 'Unknown User',
  },
  filters: {
    search: 'Search',
    type: 'Type',
    site: 'Site',
    charger: 'Charger',
    paymentStatus: 'Payment Status',
    fromDate: 'From Date',
    toDate: 'To Date',
  },
  types: {
    app: 'App',
    rfid: 'RFID',
    admin: 'Admin',
    ocpp: 'OCPP',
    backend_standalone: 'Backend',
    backend_on_behalf: 'On Behalf',
    vendor_api: 'Vendor API',
    kiosk: 'Kiosk',
  },
  paymentStatuses: {
    completed: 'Completed',
    failed: 'Failed',
    refunded: 'Refunded',
    partial_refund: 'Partial Refund',
  },
  // Status of the linked app_transactions row (pre-auth or deduction). Shown
  // as a chip next to the amount in the Payment tab.
  transactionStatuses: {
    pending: 'Pending',
    hold: 'Hold',
    released: 'Released',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    refunded: 'Refunded',
  },
  actions: {
    refresh: 'Refresh',
  },
  export: {
    button: 'Export to Excel',
    exporting: 'Exporting…',
    succeeded: 'Exported %{count} session(s) to Excel',
    failed: 'Export failed',
    empty: 'No sessions to export for the current filters',
    truncated: 'Exported the first %{exported} of %{total} sessions. Narrow the date range to capture more.',
    dateRequired: 'Please choose a date range',
    dateOrderInvalid: 'Start date must be before end date',
    sheetName: 'Charging History',
    dialog: {
      title: 'Export Charging History',
      help: 'Pick a date range by session start time. Up to %{limit} rows are returned per export — narrow the range if your dataset is larger.',
      from: 'From',
      to: 'To',
      presets: 'Quick ranges',
      preset: {
        today: 'Today',
        yesterday: 'Yesterday',
        last7days: 'Last 7 days',
        last30days: 'Last 30 days',
        thisMonth: 'This month',
        lastMonth: 'Last month',
      },
      confirm: 'Export',
    },
    col: {
      sessionId: 'Session ID',
      userName: 'User Name',
      userEmail: 'User Email',
      userPhone: 'User Phone',
      licensePlate: 'License Plate',
      chargerId: 'Charger ID',
      chargerName: 'Charger Name',
      siteName: 'Site',
      startTime: 'Start Time',
      endTime: 'End Time',
      duration: 'Charging Duration (hh:mm:ss)',
      idleDuration: 'Idle Duration (hh:mm:ss)',
      energyKwh: 'Consumed Energy (kWh)',
      chargingServiceFee: 'Charging Service Fee',
      idleFee: 'Idle Fee',
      finalCost: 'Final Cost',
      paymentStatus: 'Payment Status',
      initiatedBy: 'Initiated By',
    },
  },
  show: {
    title: 'Charging Session Details',
    sessionNumber: 'Session',
    invoice: 'Invoice',
    viewOcppLogs: 'View OCPP Logs',
    // Session Overview
    sessionSummary: 'Session Summary',
    completedSessionFrom: 'Completed session from',
    energyDelivered: 'Energy Delivered',
    sessionDuration: 'Session Duration',
    averagePower: 'Average Power',
    batteryStateOfCharge: 'Battery State of Charge',
    // Session Info
    sessionInformation: 'Session Information',
    sessionId: 'Session ID',
    transactionId: 'Transaction ID',
    invoiceNumber: 'Invoice Number',
    chargingDuration: 'Charging Duration',
    chargingStarted: 'Charging Started',
    chargingCompleted: 'Charging Completed',
    cableDisconnected: 'Cable Disconnected',
    fromChargingStartedToCableDisconnect: 'From charging started to cable disconnect',
    idleDuration: 'Idle Duration (Total)',
    gracePeriod: 'Grace Period',
    chargeableIdleTime: 'Chargeable Idle Time',
    // Charger & Location
    chargerLocation: 'Charger & Location',
    siteName: 'Site Name',
    chargerName: 'Charger Name',
    connectorId: 'Connector ID',
    address: 'Address',
    maxPower: 'Max Power',
    // User Info
    userInformation: 'User Information',
    userId: 'User ID',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    vehicle: 'Vehicle',
    vehicles: 'Vehicles',
    licensePlate: 'License Plate',
    primary: 'Primary',
    initiatedBy: 'Initiated By',
    stopReason: 'Stop Reason',
    // Cost Info
    costInformation: 'Cost Information',
    energyCost: 'Energy Cost',
    sessionFee: 'Session Fee',
    timeFee: 'Time Fee',
    idleFee: 'Idle Fee',
    discount: 'Discount',
    finalCost: 'Final Cost',
    meterReading: 'Meter Reading',
    start: 'Start',
    end: 'End',
    idle: 'Idle',
    grace: 'Grace',
    chargeable: 'Chargeable',
    minUnit: 'min',
    hrUnit: 'hr',
    max: 'Max',
    free: 'Free',
    // Payment Info
    paymentDetails: 'Payment Details',
    paymentMethod: 'Payment Method',
    paymentStatus: 'Payment Status',
    preAuthorization: 'Pre-Authorization',
    actualCharged: 'Actual Charged',
    settlementDate: 'Settlement Date',
    settlementTransaction: 'Settlement Transaction',
    // Technical Details
    technicalDetails: 'Technical Details',
    averageTemperature: 'Average Temperature',
    errors: 'Errors',
    errorCount: 'error(s)',
    last: 'Last',
    // Archive Info
    archiveInformation: 'Archive Information',
    archiveMessage: 'This session has been archived and is stored for',
    archiveMessageDays: 'days',
    archiveMessageUnlimited: 'unlimited',
    archivedAt: 'Archived At',
    originalCreated: 'Original Created',
    dataRetention: 'Data Retention',
    days: 'days',
    // Tabs
    overview: 'Overview',
    analytics: 'Analytics',
    payment: 'Payment',
    ocppLogs: 'OCPP Logs',
    technical: 'Technical',
    // Analytics Tab - Meter Values Charts
    meterReadingsSummary: 'Meter Readings Summary',
    startOfCharging: 'Start of Charging',
    endOfCharging: 'End of Charging',
    power: 'Power',
    voltage: 'Voltage',
    current: 'Current',
    meter: 'Meter',
    time: 'Time',
    totalReadingsCaptured: 'Total readings captured',
    samples: 'samples',
    showingKeyDataPoints: 'showing',
    keyDataPoints: 'key data points',
    chargingAnalytics: 'Charging Analytics',
    detailedMetricsPerformance: 'Detailed metrics and performance data',
    noChargingCurveData: 'No charging curve data available for this session.',
    energy: 'Energy',
    allMetrics: 'All Metrics',
    timeMmSs: 'Time (mm:ss)',
    powerKw: 'Power (kW)',
    voltageV: 'Voltage (V)',
    currentA: 'Current (A)',
    energyKwh: 'Energy (kWh)',
    powerKwEnergyKwh: 'Power (kW) / Energy (kWh)',
    voltageVCurrentA: 'Voltage (V) / Current (A)',
    // OCPP Logs Tab
    ocppTransactionLogs: 'OCPP Transaction Logs',
    completeOcppProtocol: 'Complete OCPP protocol communication flow for this session',
    showingLogEntries: 'Showing',
    of: 'of',
    logEntries: 'log entries',
    noOcppLogsFound: 'No OCPP logs found for this charging session. This may be because:',
    noOcppLogsReason1: 'Elasticsearch is not configured',
    noOcppLogsReason2: 'Logs have not been indexed yet',
    noOcppLogsReason3: 'The session is too old and logs have been archived',
    timestamp: 'Timestamp',
    logLevel: 'Log Level',
    messageType: 'Message Type',
    ocppAction: 'OCPP Action',
    direction: 'Direction',
    resource: 'Resource',
    error: 'Error',
    request: 'Request',
    response: 'Response',
    tags: 'Tags',
    fullLogData: 'Full Log Data',
    outgoing: 'Outgoing (OCPP Server → Charger)',
    incoming: 'Incoming (Charger → OCPP Server)',
    responseTo: 'Response to',
    status: 'Status',
    transactionIdLabel: 'Transaction ID',
    idTag: 'ID Tag',
    meterStart: 'Meter Start',
    meterStop: 'Meter Stop',
    errorLabel: 'Error',
    connector: 'Connector',
    config: 'Config',
    type: 'Type',
    id: 'ID',
  },
};

export const chargingSessions = {
  'charging-sessions': chargingSessionsResource,
};
